/**
 * Responsible for handling the dialogue ingestion from manifest
 */
import axios from "axios";
import {DialogueTree} from "../dialogue/dialogue_tree";

export class DialogueManager {
	// baseURL = "https://app.alphabatem.com/dialogues"
	baseURL = "https://shdw-drive.genesysgo.net/DPftgc8znPZ7i7svEFtu1E9fGs7AwCjsqQQNJmWvTqSD"

	//Holds cached dialogue tree's downloaded from server
	dialogueCache = {}

	//Holds the current dialogue tree thats active
	currentTree = null

	handlers = {
		"dialogue_open": [],
		"dialogue_close": [],
	}

	constructor() {
		//

		window.addEventListener("interaction-dialogue-go", (e) => this.onDialogueGo(e))
		window.addEventListener("interaction-success", (e) => this.onInteractionSuccess(e))
		window.addEventListener("interaction-error", (e) => this.onInteractionError(e))
	}

	reset() {
		window.removeEventListener("interaction-dialogue-go", (e) => this.onDialogueGo(e))
		window.removeEventListener("interaction-success", (e) => this.onInteractionSuccess(e))
		window.removeEventListener("interaction-error", (e) => this.onInteractionError(e))
	}

	setHandler(event, handler) {
		this.handlers[event].push(handler)
	}

	getCurrentTree() {
		return this.currentTree
	}

	/**
	 * Called when dialogue should show up in the scene
	 * TODO normalize to other controllers standard
	 * @param uuid
	 */
	async fromInteraction(uuid) {
		const d = await this.getDialogueTree(uuid)
		if (!d) {
			console.error("Unable to find dialogue")
			return false
		}

		console.log("Loaded tree", uuid, d)
		this.currentTree = new DialogueTree(d)
		return true
	}

	async getDialogueTree(uuid) {
		const {data} = await axios.get(`${this.baseURL}/${uuid}.json`)
		return data

		// if (!this.dialogueCache[uuid]) {
		// 	const {data} = await axios.get(`${this.baseURL}/${uuid}.json`)
		// 	this.dialogueCache[uuid] = data
		// }
		// return Object.assign({}, this.dialogueCache[uuid])
	}

	isActive() {
		return this.currentTree !== null
	}

	/**
	 * Called when user continues in the dialogue
	 */
	onContinue(data) {
		this.currentTree.onNext(data)
		if (this.currentTree.isFinished())
			this.onFinish() //Call finish
	}

	/**
	 * Called to start the dialogue
	 * @returns {Promise<void>}
	 * @param data
	 */
	async onStart(data) {
		if (!await this.fromInteraction(data.uuid))
			return

		console.log("Starting dialogue", data.uuid)

		//Call the open event
		this._callHandler("dialogue_open")
	}

	/**
	 * Called when the user exists the dialogue
	 */
	onFinish() {
		this.currentTree = null

		//Call the close event
		this._callHandler("dialogue_close")
	}


	_callHandler(eventName) {
		for (let i = 0; i < this.handlers[eventName].length; i++) {
			this.handlers[eventName][i]()
		}
	}

	/**
	 * Handles interaction trigger for moving to a new dialogue screen
	 * @param e
	 */
	onDialogueGo(e) {
		if (!this.currentTree)
			return

		console.log("onDialogueGo", e)
		this.currentTree.go(e.detail.id)
	}

	/**
	 * Handles the inbound interaction event
	 * Passed down to active tree for addition to metadata
	 * @param e
	 */
	onInteractionSuccess(e) {
		if (!this.currentTree)
			return
		this.currentTree.onInteractionSuccess(e)
	}

	/**
	 * Handles the inbound interaction event
	 * Notify active tree of error
	 * @param e
	 */
	onInteractionError(e) {
		if (!this.currentTree)
			return
		this.currentTree.onInteractionError(e)
	}
}